import { IMessage } from "../_interface/crossAppMessaging";
import { INotificationProvider, INotificationToken } from "../_interface/notificationProvider";
import { OrderStatus } from "../_interface/order";
import { CrossAppMessagingService } from "./crossApp-messaging.service";


export class NativeNotificationProvider implements INotificationProvider {
  private cancelWaiterCallFn = (tableID: number) => { };
  private setOrderStatusFn = (orderID: number, orderStatus: OrderStatus) => { };

  constructor(
    private crossAppMessaging: CrossAppMessagingService,
  ) {
  }

  cancelWaiterCall(fn: (tableID: number) => void): void {
    this.cancelWaiterCallFn = fn;
  }
  setOrderStatus(fn: (orderID: number, orderStatus: OrderStatus) => void): void {
    this.setOrderStatusFn = fn;
  }

  getToken(): Promise<INotificationToken | null> {
    var msg = {
      action: "notification_getToken"
    };

    return this.crossAppMessaging.sendRawMessage(msg, true).then(
      res => {
        if (res == null) {
          return null;
        }

        // Native vraća objekat {provider, token}; stariji bridge je vraćao (single-quoted) string.
        var jmsg = (typeof res === 'string') ? JSON.parse(res.replace(/'/g, '"')) : res;
        if (jmsg == null) {
          return null;
        }

        var token: INotificationToken = {
          token: jmsg.token,
          provider: jmsg.provider
        };
        return token;
      }
    );
  }

  removeNotification(tag: string): void {
    var msg: IMessage = {
      action: "notification_removeNotification",
      data: tag
    };

    this.crossAppMessaging.sendRawMessage(msg);
  }


}
